export enum WorkstationTssStatus {
  ACTIVE = 'ACTIVE',
  NOT_ACTIVE = 'NOT_ACTIVE'
}

export enum WorkstationTssError {
  NOT_FOUND = 'Workstation not found'
}
